"use client";
import React from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"; // ← add karoimport "../app/globals.css";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { IMAGES } from "../constants/images";
import NextLink from "next/link";
const VideoUIComponent = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        py: { xs: 3, sm: 3.5, md: 4 },
        display: "flex",
        alignItems: "center",
        mb: { xs: "5%", sm: "7%", md: "10%" },
        ml: { xs: "-2%", sm: "-2%", md: "0" },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "flex-start", md: "center" },
            px: { xs: 2, sm: 0 },
          }}
        >
          <Chip
            label={t("videoUI.chip")}
            sx={{
              backgroundColor: "white",
              border: "1px solid #0206174D",
              mb: 2,
              color: "#818E98",
              fontSize: { xs: "13px", sm: "14px", md: "16px" },
              fontWeight: "500",
              textTransform: "capitalize",
              px: { xs: 0.5, sm: 0.7 },
              py: { xs: 1.2, sm: 1.5, md: 2.3 },
              fontFamily: "var(--font-outfit)",
              borderRadius: "40px",
            }}
          />
        </Box>

        <Box
          textAlign={{ xs: "left", md: "center" }}
          mb={{ xs: 4, sm: 5, md: 8 }}
          px={{ xs: 2, sm: 0 }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontWeight: "600",
              mb: 1.5,
              color: "#020617",
              fontSize: {
                xs: "1.75rem",
                sm: "2rem",
                md: "2rem",
                lg: "2.3rem",
                xl: "2.6rem",
              },
              lineHeight: 1.2,
              fontFamily: "var(--font-plusjakarta)",
              maxWidth: { xs: "100%", md: 1200 },
              textAlign: { xs: isArabic ? "right" : "left", md: "center" },
              mx: { xs: 0, md: "auto" },
            }}
          >
            {t("videoUI.title1")}
            <span style={{ color: "#775CE5" }}>
              {t("videoUI.titleHighlight")}
            </span>
            {t("videoUI.title2")}
          </Typography>

          <Typography
            sx={{
              color: "#81838c",
              fontWeight: "400",
              fontSize: {
                xs: "16px",
                sm: "18px",
                md: "20px",
                lg: "16px",
                xl: "20px",
              },
              fontFamily: "var(--font-outfit)",
              maxWidth: { xs: "100%", md: 1000 },
              textAlign: { xs: isArabic ? "right" : "left", md: "center" },
              mx: { xs: 0, md: "auto" },
              mt: "1.5%",
            }}
          >
            {t("videoUI.subtitle1")}
          </Typography>
          {/* <Typography
            sx={{
              color: "#81838c",
              fontWeight: "400",
              fontSize: {
                xs: "16px",
                sm: "18px",
                md: "20px",
                lg: "16px",
                xl: "20px",
              },
              maxWidth: { xs: "100%", md: 900 },
              fontFamily: "var(--font-outfit)",
              textAlign: { xs: isArabic ? "right" : "left", md: "center" },
              mx: { xs: 0, md: "auto" },
              mt: "1%",
            }}
          >
            {t("videoUI.subtitle2")}
          </Typography> */}
        </Box>

        {/* Video Grid Section - Centered */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: { xs: 0, md: "-1.2%" },
            px: { xs: 2, sm: 0 },
          }}
        >
          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4 }}
            justifyContent={"center"}
            sx={{
              minWidth: {
                xs: "100%",
                md: "1200px",
                lg: "1100px",
                xl: "1200px",
              },
              maxWidth: {
                xs: "100%",
                md: "1200px",
                lg: "1100px",
                xl: "1200px",
              },
            }}
          >
            {/* Left Video Box - Hiring is broken */}
            <Grid item size={{ xs: 12, md: 6 }}>
              <Paper
                elevation={3}
                sx={{
                  bgcolor: "#F6F8FC",
                  borderRadius: { xs: 2, sm: 2.5, md: 3 },
                  pt: { xs: 2.5, sm: 3, md: 4 },
                  px: { xs: 2.5, sm: 3, md: 4 },
                  height: "auto",
                  boxShadow: "none",
                  overflow: "hidden",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    mb: { xs: 1.5, sm: 1.5, md: 2 },
                    color: "#020617",
                    fontFamily: "var(--font-plusjakarta)",
                    fontSize: { xs: "1.25rem", sm: "1.35rem", md: "1.5rem" },
                    textAlign: isArabic ? "right" : "left",
                  }}
                >
                  {t("videoUI.card1Title")}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#81838c",
                    mb: { xs: 2, sm: 2.5, md: 3 },
                    lineHeight: 1.6,
                    fontFamily: "var(--font-outfit)",
                    maxWidth: { xs: "100%", sm: "100%", md: "50rem" },
                    fontSize: { xs: "0.9rem", sm: "0.95rem", md: "1.05rem" },
                    fontWeight: 400,
                    textAlign: isArabic ? "right" : "left",
                  }}
                >
                  {t("videoUI.card1Desc")}
                </Typography>

                {/* Video Box */}
                <Box
                  sx={{
                    position: "relative",
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "calc(100% + 60px)",
                    },
                    borderRadius: { xs: 2, sm: 2, md: 0 },
                    overflow: "hidden",
                    boxShadow: "none",
                    height: "100%",
                    margin: {
                      xs: "0",
                      sm: "0",
                      md: "0 -32px",
                    },
                    mt: { xs: 1, sm: 1, md: 0 },
                  }}
                >
                  <Box
                    component="video"
                    autoPlay
                    loop
                    muted
                    playsInline
                    title="Traditional recruiting software problems - manual processes and hiring delays"
                    controlsList="nodownload noremoteplayback nofullscreen"
                    disablePictureInPicture
                    onContextMenu={(e) => e.preventDefault()}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  >
                    <source src={IMAGES.HIRING_BROKEN_VIDEO} type="video/mp4" />
                  </Box>
                </Box>
              </Paper>
            </Grid>

            {/* Right Video Box - We fix it */}
            <Grid item size={{ xs: 12, md: 6 }}>
              <Paper
                elevation={3}
                sx={{
                  bgcolor: "black",
                  borderRadius: { xs: 2, sm: 2.5, md: 3 },
                  pt: { xs: 2.5, sm: 3, md: 3.3 },
                  px: { xs: 2.5, sm: 3, md: 4, lg: 5.5, xl: 4 },
                  height: "auto",
                  boxShadow: "none",
                  overflow: "hidden",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    mb: { xs: 1.5, sm: 1.5, md: 2 },
                    color: "white",
                    fontFamily: "var(--font-plusjakarta)",
                    fontSize: { xs: "1.25rem", sm: "1.35rem", md: "1.5rem" },
                    textAlign: isArabic ? "right" : "left",
                  }}
                >
                  {t("videoUI.card2Title")}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#81838c",
                    mb: { xs: 2, sm: 2.5, md: 3 },
                    lineHeight: 1.6,
                    fontFamily: "var(--font-outfit)",
                    maxWidth: { xs: "100%", sm: "100%", md: "50rem" },
                    fontSize: { xs: "0.9rem", sm: "0.95rem", md: "1.05rem" },
                    fontWeight: 400,
                    textAlign: isArabic ? "right" : "left",
                  }}
                >
                  {t("videoUI.card2Desc")}
                </Typography>

                {/* Video Box */}
                <Box
                  sx={{
                    position: "relative",
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "calc(100% + 64px)",
                    },
                    borderRadius: { xs: 2, sm: 2, md: 0 },
                    overflow: "hidden",
                    boxShadow: "none",
                    height: "100%",
                    margin: {
                      xs: "0",
                      sm: "0",
                      md: "0 -32px",
                    },
                    mt: { xs: 1, sm: 1, md: 0 },
                  }}
                >
                  <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
                    <Button
                      variant="contained"
                      component="a"
                      endIcon={
                        isArabic ? (
                          <ChevronLeftIcon
                            sx={{
                              fontSize: {
                                xs: "1rem",
                                sm: "1.1rem",
                                md: "1.2rem",
                              },
                              mr: "50%",
                              mt: "4%",
                            }}
                          />
                        ) : (
                          <ChevronRightIcon
                            sx={{
                              fontSize: {
                                xs: "1rem",
                                sm: "1.1rem",
                                md: "1.2rem",
                              },
                              mt: "4%",
                            }}
                          />
                        )
                      }
                      sx={{
                        position: "absolute",
                        top: { xs: 12, sm: 14, md: 16 },
                        left: isArabic ? "auto" : { xs: 12, sm: 14, md: 16 },
                        right: isArabic ? { xs: 12, sm: 14, md: 16 } : "auto",
                        zIndex: 2,
                        ml: isArabic ? 0 : { md: "3.2%" },
                        mr: isArabic ? { md: "3.2%" } : 0,
                        bgcolor: "white",
                        color: "#775CE5",
                        textTransform: "none",
                        fontSize: { xs: "0.85rem", sm: "0.9rem", md: "1rem" },
                        fontWeight: 500,
                        fontFamily: "var(--font-outfit)",
                        px: { xs: 1.5, sm: 1.75, md: 2 },
                        py: { xs: 0.75, sm: 0.85, md: 1 },
                        boxShadow: "none",
                        borderRadius: { xs: 6, sm: 7, md: 8 },
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          bgcolor: "#f9fafb",
                          boxShadow: "none",
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      {t("videoUI.card2Cta")}
                    </Button>
                  </NextLink>
                  <Box
                    component="video"
                    autoPlay
                    loop
                    muted
                    playsInline
                    controlsList="nodownload noremoteplayback nofullscreen"
                    disablePictureInPicture
                    onContextMenu={(e) => e.preventDefault()}
                    title="AI recruiting tool solution - automated recruitment automation software workflow"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      marginTop: { xs: 6, sm: 0, md: 0 },

                    }}
                  >
                    <source
                      src={IMAGES.HIRING_SOLUTION_VIDEO}
                      type="video/mp4"
                    />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default VideoUIComponent;
